if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      const target = this.querySelector('[data-delivery-estimate-value]');
      if (!target) return;

      const firstValue = Math.max(1, Number(this.dataset.minDays) || 1);
      const secondValue = Math.max(1, Number(this.dataset.maxDays) || firstValue);
      const minDays = Math.min(firstValue, secondValue);
      const maxDays = Math.max(firstValue, secondValue);
      const businessDays = this.dataset.businessDays === 'true';
      const today = new Date();
      today.setHours(12, 0, 0, 0);

      const firstDate = this.addDays(today, minDays, businessDays);
      const lastDate = this.addDays(today, maxDays, businessDays);
      const detailed = this.dataset.dateStyle === 'long';
      const crossesYear = firstDate.getFullYear() !== lastDate.getFullYear();
      const options = detailed
        ? { weekday: 'short', day: 'numeric', month: 'long', ...(crossesYear ? { year: 'numeric' } : {}) }
        : { day: 'numeric', month: 'short', ...(crossesYear ? { year: 'numeric' } : {}) };
      const formatter = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang, options);
      const firstLabel = formatter.format(firstDate);
      const lastLabel = formatter.format(lastDate);

      target.textContent = firstDate.getTime() === lastDate.getTime() ? firstLabel : `${firstLabel} – ${lastLabel}`;
      this.hidden = false;
    }

    addDays(startDate, days, businessDays) {
      const date = new Date(startDate);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (!businessDays || day !== 0 && day !== 6) added += 1;
      }
      return date;
    }
  });
}
